import React, { Component } from 'react';
import CloudPanel from '@components/CloudPanel/CloudPanel';
import { Container, Row, Col } from 'reactstrap';
import News from '@components/News/individualNews';
import Helmet from 'react-helmet';

class NewsView extends Component {
  render() {
    const isMobile = this.props.pageWidth < 992;
    let className = '';
    if (isMobile) {
      className = 'pt-5 mt-5 mb-5';
    } else {
      className = 'abs-container d-flex align-items-center h-100';
    }

    const newsIndex = News.findIndex(item => item.slug === this.props.slug);
    return (
      <CloudPanel
        id={'news-item'}
        hideJSILogo={true}
        screenHeight={this.props.pageHeight}
      >
        <Helmet>
          <title>
            JetSuite | Private Jet Charter Flights – Private Jet Rental Service
          </title>
          <meta name="description" content={''} />
        </Helmet>
        <div className={className}>
          <Container>
            <Row>
              <Col xl={10} lg={10} md={12} className={'mx-auto'}>
                <div
                  className={'background-white p-5'}
                  style={
                    isMobile
                      ? { marginBottom: '100px' }
                      : { maxHeight: '500px', overflowY: 'auto' }
                  }
                >
                  {News[newsIndex].content}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </CloudPanel>
    );
  }
}
export default NewsView;



// WEBPACK FOOTER //
// ./src/components/NewsView/NewsView.jsx